import React, { useState } from "react";
import { useMediaQuery } from 'react-responsive';
import NavbarMob from "../components/NavbarMob";
import Navbar from "../components/Navbar";
import Navbar2 from "../components/Navbar2";
import Navbar2Mob from "../components/Navbar2Mob";
import Footer from "../components/Footer";

function BackupButton() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const [loading, setLoading] = useState(false);

    const getErrorMessage = async (response) => {
        const contentType = response.headers.get("content-type") || "";

        if (contentType.includes("application/json")) {
            const data = await response.json();
            return data.error || data.message || response.statusText;
        }

        const text = await response.text();
        return text || response.statusText;
    };

    const handleBackup = async () => {
        try {
            setLoading(true); // Start loading spinner

            const response = await fetch(`${apiBaseUrl}/backup-database`, {
                method: "GET",
            });

            if (!response.ok) {
                const message = await getErrorMessage(response);
                throw new Error(`Backup failed (${response.status}): ${message}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            const disposition = response.headers.get("Content-Disposition");
            let filename = "database_backup.bak";
            if (disposition && disposition.includes("filename=")) {
                filename = disposition.split("filename=")[1].replace(/"/g, "");
            }

            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            alert("Backup downloaded successfully!");
        } catch (err) {
            console.error(err);
            alert(err.message || "Backup failed. Check console for details.");
        } finally {
            setLoading(false); // Stop loading spinner
        }
    };

    return (
        <div className="min-h-screen flex flex-col">
            {/* Header */}
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className='md:flex hidden'>
                <Navbar2 />
            </div>
            <div className='md:hidden flex flex-col'>
                <Navbar2Mob />
            </div>

            {/* Main content */}
            <main className="flex-grow flex items-center justify-center">
                <div className="bg-white rounded-lg shadow-md p-6 md:p-8 text-center max-w-xs w-full">
                    <h2 className="text-lg md:text-xl font-semibold mb-4">Database Backup</h2>
                    <p className="text-sm text-gray-600 mb-6">Click the button below to download the latest backup of the database.</p>

                    <button
                        onClick={handleBackup}
                        className="relative mx-auto bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold px-4 py-2 rounded-lg shadow-md hover:scale-105 hover:shadow-lg transition transform duration-300 text-sm md:text-base flex items-center justify-center"
                        disabled={loading}
                    >
                        {loading && (
                            <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                            </svg>
                        )}
                        {loading ? "Downloading..." : "Download Backup"}
                    </button>

                </div>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default BackupButton;
